import { useEffect, useState } from "react";
import styles from "./SAPAuthorizationFailed.module.css";

const SAPAuthorizationFailed = () => {
  const { REACT_APP_ENVIRONMENT } = process.env;
  const [currentEnvironment, setCurrentEnvironment] = useState("")
  useEffect(()=>{
    setCurrentEnvironment(REACT_APP_ENVIRONMENT.charAt(0).toUpperCase() + REACT_APP_ENVIRONMENT.slice(1));
  },[])

  return (
    <>
      <header className={styles.header}>
        <div className={styles["title-container"]}>
          <h6 className={styles["title-header"]}>
            Digital Young Learners Admin Portal
          </h6>
        </div>
      </header>

      <div className={styles.main}>
        <div className={styles["title-message"]}>
          <h1>{currentEnvironment}</h1>

          <p>You do not have access to this environment.</p>
        </div>

        <div className={styles["body-contaner"]}>
          <p>
            Please raise a Service Request if you need access to this
            environment, otherwise You may have been looking for one of these
            environments:
          </p>
          <div className={styles["env-links"]}>
          <a href="https://ceqdyl-admin.cambridge.org/">Production</a>
            <a href="https://dev-ceqdyl-admin.cambridgedev.org/">Dev</a>
            <a href="https://preview-ceqdyl-admin.cambridgedev.org/">Preview</a>
            <a href="https://staging-ceqdyl-admin.cambridgedev.org/">Staging</a>
          </div>
        </div>
      </div>
    </>
  );
};

export default SAPAuthorizationFailed;
